import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-6 pt-0"},[_c(VAlert,{staticClass:"ma-0 align-center",attrs:{"type":"success","prominent":"","text":""}},[_c('div',{staticClass:"d-flex align-center"},[_c('span',{staticClass:"text--primary",domProps:{"innerHTML":_vm._s(_vm.successText)}}),_c(VBtn,{attrs:{"text":""},on:{"click":function($event){return _vm.$emit('dismiss')}}},[_vm._v(" Dismiss ")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }